import { stringify } from 'query-string';
import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';

import { ApiPresentation } from '../all_index/get';

type Option = {
  id: string | number;
  /** ログインユーザーがわく寄付の投票できるかの判定の際に必要 */
  competitionId?: string | number;
};

function getPath({ id, competitionId }: Option) {
  let path = `/v1/presentations/${id}`;
  if (competitionId) {
    path += `?${stringify({ competition_id: competitionId })}`;
  }
  return path;
}

export async function apiGetV1PresentationById(option: Option) {
  const response = await request.GET<{ presentation: ApiPresentation }>(getPath(option));
  return response.presentation;
}

export function useSWRV1PresentationById(option: Option) {
  const swr = useSWR(getPath(option), () => apiGetV1PresentationById(option), SWR_GLOBAL_CONFIG);
  return { ...swr, presentation: swr.data };
}
